import {
  Folder,
  FolderOpen,
  Bookmark,
  Code,
  Palette,
  BookOpen,
  Briefcase,
  Video,
  Music,
  Camera,
  ShoppingBag,
  Lightbulb,
  Heart,
  Star,
  Rocket,
  Target,
  Award,
  Coffee,
  Home,
  Laptop,
  type LucideIcon,
} from 'lucide-react';

export interface IconOption {
  name: string;
  icon: LucideIcon;
  label: string;
}

export const collectionIcons: IconOption[] = [
  { name: 'folder', icon: Folder, label: '폴더' },
  { name: 'folder-open', icon: FolderOpen, label: '열린 폴더' },
  { name: 'bookmark', icon: Bookmark, label: '북마크' },
  { name: 'code', icon: Code, label: '코드' },
  { name: 'palette', icon: Palette, label: '디자인' },
  { name: 'book-open', icon: BookOpen, label: '책' },
  { name: 'briefcase', icon: Briefcase, label: '업무' },
  { name: 'video', icon: Video, label: '비디오' },
  { name: 'music', icon: Music, label: '음악' },
  { name: 'camera', icon: Camera, label: '사진' },
  { name: 'shopping-bag', icon: ShoppingBag, label: '쇼핑' },
  { name: 'lightbulb', icon: Lightbulb, label: '아이디어' },
  { name: 'heart', icon: Heart, label: '좋아요' },
  { name: 'star', icon: Star, label: '즐겨찾기' },
  { name: 'rocket', icon: Rocket, label: '로켓' },
  { name: 'target', icon: Target, label: '목표' },
  { name: 'award', icon: Award, label: '업적' },
  { name: 'coffee', icon: Coffee, label: '휴식' },
  { name: 'home', icon: Home, label: '홈' },
  { name: 'laptop', icon: Laptop, label: '노트북' },
];

export const getIconByName = (name: string): LucideIcon => {
  const iconOption = collectionIcons.find(i => i.name === name);
  return iconOption ? iconOption.icon : Folder;
};
